export * from "./e-subtheme-default-editor-shape-embedded-acceptor-edge";
